// This icon file is generated automatically.
var PFileWordOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.35 3.5L9 .16A.5.5 0 008.64 0H2a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V3.86a.5.5 0 00-.15-.35zm-1 .6H8.4V1.14l2.94 2.94zm.03 8.78H2.62V1.12h4.72V4.5c0 .36.3.66.66.66h3.38v7.71zm-4.13-6.5h-.5a.19.19 0 00-.18.14l-.78 3.1-.72-3.1a.19.19 0 00-.18-.14H4.29a.19.19 0 00-.14.23l1.16 4.31c.02.08.1.14.18.14H6c.09 0 .16-.05.18-.14L7 7.85l.82 3.07c.03.08.1.14.19.14h.5c.08 0 .15-.05.17-.14l1.17-4.3v-.06c0-.1-.08-.18-.18-.18H9.1a.19.19 0 00-.18.14L8.2 9.63l-.78-3.11a.19.19 0 00-.18-.14z", "fill-rule": "nonzero" } }] }, "name": "p-file-word", "theme": "outlined" };
export default PFileWordOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFileWordOutlined.js
// module id = 3406
// module chunks = 0